import BaseService from "@client.services/baseService";

export default class MeetingsService extends BaseService {
  constructor() {
    super("meeting", true);
  }

  normilizeFilter = (filter) => {
    // eslint-disable-next-line no-unused-vars
    const { dateType, ...restFilter } = filter;

    return restFilter;
  };

  async getTimeMeetingParticipants(filter, isCostIndexPresentation) {
    return super.api("timeParticipants", {
      ...this.normilizeFilter(filter),
      isCostIndexPresentation,
    });
  }

  async getTopTimeParticipants(filter) {
    return super.api("topTimeParticipants", this.normilizeFilter(filter));
  }

  async getTotalMeetingsCost(filter, isCostIndexPresentation) {
    return super.api("totalMeetingsCost", {
      ...this.normilizeFilter(filter),
      isCostIndexPresentation,
    });
  }

  async getTopMeetingParticipants(filter) {
    return super.api("topMeetingParticipants", this.normilizeFilter(filter));
  }

  async getTopTimeConsumingMeetings(filter) {
    return super.api("topTimeConsumingMeetings", this.normilizeFilter(filter));
  }

  async getTimeSpent(filter) {
    return super.api("timeSpent", this.normilizeFilter(filter));
  }

  async export(filter, locale, isCostIndexPresentation) {
    return super.api(
      "export",
      { ...this.normilizeFilter(filter), locale, isCostIndexPresentation },
      false,
      true
    );
  }

  async getMeetings(filter, isCostIndexPresentation, insightId = null) {
    return super.api("meetings", {
      ...this.normilizeFilter(filter),
      isCostIndexPresentation,
      ...(insightId && { insightId }),
    });
  }
}
